import Header from "./components/Header/Header";
// import Breadcrumb from "./components/Utility/Breadcrumb/Breadcrumb";
import "@fortawesome/react-fontawesome";
import "@fortawesome/fontawesome-svg-core";
import "@fortawesome/free-regular-svg-icons";
import Footer from "./components/Footer/Footer";
import { Outlet } from "react-router-dom";
import AuthContext from "./contexts/auth";
import { useContext, useEffect,useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "./redux/Role";
import "./assets/css/main.css";
import "./assets/css/font.css";
import "./assets/css/custom-properties.css";
import { Helmet } from "react-helmet";
import HeaderRegione from "./components/HeaderRegione/HeaderRegione";
import "./App.css";
import EnvironmentContext from "./contexts/environment";
import Loading from "./components/Main/Loading/Loading";
import packageJson from '../package.json';

function App() {
  const [envLoaded, setEnvLoaded] = useState(false);
  const envContext = useContext(EnvironmentContext);
  const authContext = useContext(AuthContext);
  const isAuthenticated = authContext.isLoggedIn;
  const roles = useSelector((state) => state.role);

  useEffect(() => {  
    console.log(packageJson.version);

    async function loadEnvironment() {
      await envContext.loadEnvironment();
      console.log('loadEnvironment');
      setEnvLoaded(true);
    }
    loadEnvironment();
  }, []);

  const dispatch = useDispatch();
  useEffect(() => {  
    if (isAuthenticated) {
      console.log('dispatch app.js');
      dispatch(fetchData());
    }
  }, [dispatch, isAuthenticated]);

  return (
    <>
      <Helmet>
        <script
          src={process.env.PUBLIC_URL + "/js/componentsJs.js"}
          type="text/javascript"
        />
      </Helmet>

      <HeaderRegione />

      {isAuthenticated && <Header />}

      {isAuthenticated && !roles.authorities ? (
        <Loading />
      ) : (
        envLoaded && (
          <main>
            <Outlet></Outlet>
            <div className="rtds-mb-4 ">
              <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>
              <p className="rtds-text-center ">
                Per eventuali quesiti è possibile inoltrare una mail a{" "}
                <a
                  className="rtds-link "
                  style={{ textDecoration: "underline" }} 
                  href="mailto:librigratis@regione.toscana.it"
                >
                  librigratis@regione.toscana.it
                </a>
              </p>
            </div>
          </main>
        )
      )}

      <Footer />
    </>
  );
}

export default App;
